// import firebase from 'firebase';
import "firebase/auth";
import "firebase/storage";
import "firebase/database";
import "firebase/functions";


import firebaseConfig from './fbConfig';
import firebase from "firebase/compat/app";
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
// const firebaseConfig = {
//     apiKey: "AIzaSyBo8yIWUE9UBfiU1OhEIu2QtgY2T_xbCAg",
//     authDomain: "test-1c6eb.firebaseapp.com",
//     databaseURL: "https://test-1c6eb.firebaseio.com",
//     projectId: "test-1c6eb",
//     storageBucket: "test-1c6eb.appspot.com",
//     messagingSenderId: "60602324384",
//     appId: "1:60602324384:web:0e335effff3f936d1b00c5"
// };

var fire = initializeApp(firebaseConfig.config);
const fireDatabase = getDatabase(fire);
 const fireFunctions = getFunctions(fire);
        // connectFunctionsEmulator(fireFunctions, "127.0.0.1", 5001);
export {fireDatabase, fire, fireFunctions}

// export default fire;